import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const evaluateBService = {
  addformsetup,
  addchoices,
  getAllChoices,
  getAllTitles,
  getAllFormsetup,
  updateFormSetup,
  getAllFormView,
  saveFormViews,
  clearFormViews,
  getAllSavedFormView,
  DeleteFormViews,
  getallsubForms
};

async function addformsetup(newItem) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newItem),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function addchoices(newchoice) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newchoice),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/choice/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllChoices(node_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/choice/getAll/${node_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}
async function getAllTitles(node_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form/getAll/Titles/${node_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllFormsetup(node_id, title_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form/getAll/${node_id}/${title_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function updateFormSetup(updateFormSetup, id) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(updateFormSetup),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form/update/${id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
async function getAllFormView(node_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form-view/getAll/${node_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function saveFormViews(newForms) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newForms),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form-view/save/all`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllSavedFormView(node_id, form_id, user_id, user_table_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form-view/getAllSubmittedForms/${node_id}/${form_id}?lg_u_id=${user_id}&lg_u_t_id=${user_table_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function clearFormViews(newForms) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newForms),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form-view/update/all`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function DeleteFormViews(newForms) {
  const configOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newForms),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form-view/delete/all`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}
async function getallsubForms(node_id,form_id) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/eveluate_b/form-view/getAll-Sub/${node_id}/${form_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}